
export default function Features() {
  const features = [
    {
      icon: 'ri-robot-2-line',
      title: 'AI Material Take-Off',
      description: 'Upload plans and let AI automatically calculate materials with 95%+ accuracy',
    },
    {
      icon: 'ri-timer-flash-line',
      title: '5-Minute Quotes',
      description: 'Generate professional quotes in minutes, not hours',
    },
    {
      icon: 'ri-file-pdf-line',
      title: 'Branded PDF Export',
      description: 'Export quotes with your logo and branding instantly',
    },
    {
      icon: 'ri-calculator-line',
      title: 'Profit Calculator',
      description: 'Built-in margin calculator ensures you never underquote',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Mobile-First Design',
      description: 'Quote on-site from your phone or tablet',
    },
    {
      icon: 'ri-team-line',
      title: 'Team Collaboration',
      description: 'Share quotes and projects with your team in real-time',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
            Everything You Need to <span className="text-amber-500">Quote Faster</span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Built specifically for Australian tradies who want to spend less time quoting and more time on the tools
          </p>
        </div>

        {/* Features Grid - Mobile Optimized */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 sm:p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-amber-100 rounded-lg flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${feature.icon} text-3xl sm:text-4xl text-amber-500`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
